import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Box, Button, Code, Container, Flex, Heading, Text, useDisclosure, useToast } from "@chakra-ui/react";
import { AttachmentIcon, DownloadIcon } from "@chakra-ui/icons"
import { BaseResultModel } from "../models/BaseResultModel.tsx"


export default function ResultForm() {
    const toast = useToast();
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [baseResult, setBaseResult] = useState<string>('')

    const onDrop = (acceptedFiles: File[]) => {
        if (acceptedFiles.length === 0) {
            toast({
                position: 'top',
                title: 'Fișierul încărcat nu este o arhivă .zip',
                duration: 5000,
                status: 'warning',
                variant: 'left-accent',
                isClosable: true,
            })
        }
    }

    const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
        onDrop,
        multiple: false,
        accept: {
            'application/zip': ['.zip'],
        }
    });

    const incarcareArhiva = async (arhiva: File) => {
        const formData = new FormData();
        formData.append("examen", arhiva, arhiva.name);
        const response = await fetch('/api/result', {
            method: "POST",
            body: formData,
        }).catch(e => console.log(e))

        while (acceptedFiles.length > 0) {
            acceptedFiles.pop();
        }

        if (response!.status !== 200) {
            const errorDetail = await response!.json();
            toast({
                position: 'top',
                title: `Eroare la încărcare [${response!.status}]: `,
                description: errorDetail.detail,
                duration: 5000,
                status: 'error',
                variant: 'left-accent',
                isClosable: true,
            })

            return;
        }

        const rawBaseResult = await response!.json() as BaseResultModel;
        setBaseResult(rawBaseResult.digest_value.toString())

        onOpen();
    }

    return (
        <Flex flexDirection={'column'} gap={5} flex={1} alignItems={'center'}>
            <Modal
                isOpen={isOpen}
                onClose={onClose}
                size={'xl'}>
                <ModalOverlay>
                    <ModalContent>
                        <ModalHeader fontSize='lg' fontWeight='bold'>
                            Examen încărcat
                        </ModalHeader>

                        <ModalBody>
                            <Text colorScheme="purple" fontWeight={"bold"}>Valoare digest:</Text>
                            <Text size={'xs'}>{baseResult}</Text>
                        </ModalBody>

                        <ModalFooter>
                            <Button onClick={onClose}>
                                Închide
                            </Button>
                        </ModalFooter>
                    </ModalContent>
                </ModalOverlay>
            </Modal>
            <Container bg={acceptedFiles.length === 0 ? "gray.200" : "green.200"} borderRadius="8px" border="2px" borderStyle="dashed" p={3} borderColor={acceptedFiles.length === 0 ? "gray.400" : "green.400"} alignContent={'center'}>
                <Box  {...getRootProps()} display={'flex'} flexDirection={'column'} gap={2} justifyContent={'center'} p={5}>
                    <input {...getInputProps()} />
                    <Heading as={'h3'} size={'md'}>
                        Încărcare arhivă .zip cu codul sursă
                    </Heading>
                    <Text>{acceptedFiles.length === 0 ? 'Niciun fișier încărcat' : acceptedFiles[0].name}</Text>
                    <Box as="div"><AttachmentIcon fontSize={'2rem'} /></Box>

                </Box>
            </Container>
            <Button leftIcon={<DownloadIcon />} colorScheme="teal" w={'auto'} isDisabled={acceptedFiles.length === 0} onClick={() => incarcareArhiva(acceptedFiles[0])}>Încărcare</Button>
        </Flex >
    );
}